module.exports = __webpack_public_path__ + "static/media/pkm-reb2.f000cd56.JPG";